import React, { useEffect, useState } from "react";
import {
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  AutocompleteInput,
  useRedirect,
  useRefresh,
  useDataProvider,
  CreateProps,
} from "react-admin";
import { CcaAcademicYearResources, GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import CustomEndDateInput from "components/CustomEndDateInput";
import moment from "moment";
import { typeList } from "pages/holidays/const";
import CreateWrapper from "../../components/CreateWrapper";

const HolidayCreate = (props: CreateProps) => {
  const [holidays, setHolidays] = useState<ICcaHoliday[]>([]);
  const provider = useDataProvider();
  const param = GetParam();
  const redirect = useRedirect();
  const refresh = useRefresh();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    {
      title: "Academic Years",
      link: `/schools/${param.get("schoolId")}/show/4`,
    },
    {
      title: "Holidays",
      link: `/ccaAcademicYears/${param.get("ccaAcademicYearId")}/show/2`,
      params: `?schoolId=${param.get("schoolId")}`,
    },
    { title: "Create", link: "" },
  ];

  const CustomRedirect = () => {
    redirect(
      `/ccaAcademicYears/${param.get(
        "ccaAcademicYearId"
      )}/show/2?schoolId=${param.get("schoolId")}`
    );
    refresh();
  };

  const academicYearResources = CcaAcademicYearResources(
    Number(param.get("ccaAcademicYearId"))
  );

  useEffect(() => {
    provider
      .getList("ccaHolidays", {
        filter: { CcaAcademicYearId: Number(param.get("ccaAcademicYearId")) },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "Id",
          order: "ASC",
        },
      })
      .then(({ data }) => {
        setHolidays(data as ICcaHoliday[]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let excludeDates: IExcludeDates[] = [];
  holidays.forEach((holiday: ICcaHoliday) => {
    let temp: IExcludeDates = {
      startDate: holiday.date,
    };

    excludeDates.push(temp);
  });

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New CCA Holiday"
        onSuccess={CustomRedirect}
        {...props}
      >
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">
                Academic Year and Holiday Type
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select Academic Year"
                source="ccaAcademicYearId"
                reference="ccaAcademicYears"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <AutocompleteInput
                source="type"
                choices={typeList}
                validate={required()}
                disabled
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>
            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={4}>
              <CustomEndDateInput
                source="date"
                label="Date"
                parentStartDate={moment
                  .utc(academicYearResources?.startDate)
                  .format("yyyy-MM-DD")}
                parentEndDate={moment
                  .utc(academicYearResources?.endDate)
                  .format("yyyy-MM-DD")}
                excludeDates={excludeDates}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default HolidayCreate;
